import type { ProjectId } from 'owa-timestream-types';
import { useEffect } from 'react';
import subscribeToAssetNotifications from './assetNotifications/subscribeToAssetNotifications';
import unsubscribeFromAssetNotifications from './assetNotifications/unsubscribeFromAssetNotifications';

export default function useAssetNotifications(projectId: ProjectId) {
    useEffect(() => {
        const subscriptionId = `${projectId}.${Date.now()}.${Math.floor(Math.random() * 100)}`;
        subscribeToAssetNotifications(subscriptionId, projectId);
        return () => {
            unsubscribeFromAssetNotifications(subscriptionId);
        };
    }, [projectId]);
}
